import { render } from "./ColorBarHorizontal.vue?vue&type=template&id=447bfd9f&scoped=true&ts=true"
import script from "./ColorBarHorizontal.vue?vue&type=script&lang=ts"
export * from "./ColorBarHorizontal.vue?vue&type=script&lang=ts"

import "./ColorBarHorizontal.vue?vue&type=style&index=0&id=447bfd9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447bfd9f"]])

export default __exports__